export enum TokenCustomClaimKeysEnum {
  ORG_DISPLAY_NAME = 'https://auth.sitecorecloud.io/claims/org_display_name',
  ORG_ID = 'https://auth.sitecorecloud.io/claims/org_id',
  ORG_NAME = 'https://auth.sitecorecloud.io/claims/org_name',
  ROLES = 'https://auth.sitecorecloud.io/claims/roles',
  ORG_TYPE = 'https://auth.sitecorecloud.io/claims/org_type',
}
interface ITokenClaims {
  __raw: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  middle_name?: string;
  nickname?: string;
  preferred_username?: string;
  profile?: string;
  picture?: string;
  website?: string;
  email?: string;
  email_verified?: boolean;
  gender?: string;
  birthdate?: string;
  zoneinfo?: string;
  locale?: string;
  phone_number?: string;
  phone_number_verified?: boolean;
  address?: string;
  updated_at?: string;
  iss?: string;
  aud?: string;
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
  azp?: string;
  nonce?: string;
  auth_time?: string;
  at_hash?: string;
  c_hash?: string;
  acr?: string;
  amr?: string;
  sub_jwk?: string;
  cnf?: string;
  sid?: string;
  org_id?: string;
  [TokenCustomClaimKeysEnum.ORG_DISPLAY_NAME]: string;
  [TokenCustomClaimKeysEnum.ORG_ID]: string;
  [TokenCustomClaimKeysEnum.ORG_DISPLAY_NAME]: string;
  [TokenCustomClaimKeysEnum.ROLES]: string[];
  [TokenCustomClaimKeysEnum.ORG_TYPE]: string;
  [key: string]: any;
}

export { ITokenClaims };
